import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import './CartIcon.scss';

const CartIcon = ({ isScrolled = false }) => {
    const { itemCount } = useCart();

    // Display "99+" if count exceeds 99
    const displayCount = itemCount > 99 ? '99+' : itemCount;

    return (
        <Link
            to="/cart"
            className={`jk-cart-icon ${isScrolled ? 'jk-cart-icon--scrolled' : ''}`}
            aria-label={`Shopping cart with ${itemCount} items`}
        >
            <ShoppingCart size={20} />
            {itemCount > 0 && (
                <span className="jk-cart-icon__badge">
                    {displayCount}
                </span>
            )}
        </Link>
    );
};

export default CartIcon;
